import { useCallback, useSyncExternalStore } from 'react';

import type { FlagDefinition } from './flag';
import { useFlagsClient } from './use-flags-client.hook';

export function useFlagEnabled(flag: FlagDefinition): boolean {
  const client = useFlagsClient();

  const getSnapshot = useCallback(() => client.isEnabled(flag), [client, flag]);

  return useSyncExternalStore(client.subscribe, getSnapshot, getSnapshot);
}
